import { createContext, useContext } from "react";

const HandoffCtx = createContext({ family: null, strategy: null, expiry: null, dte: null });

export function WorkspaceHandoffProvider({ value, children }) {
  return (
    <HandoffCtx.Provider value={value || { family: null, strategy: null, expiry: null, dte: null }}>
      {children}
    </HandoffCtx.Provider>
  );
}

export function useWorkspaceHandoff() {
  return useContext(HandoffCtx);
}
